export default __webpack_public_path__ + "static/media/image.d6379d03.jpg";